// extracted by mini-css-extract-plugin
export var billingAddress = "_y3-g";
export var contactInfo = "_y3-d";
export var customerInfoContainer = "_y3-c";
export var customerInfoContainerMobile = "_y3-h";
export var customerInfoRow = "_y3-a";
export var customerInfoSection = "_y3-b";
export var fullWidthDividerMobile = "_y3-i";
export var imageContainer = "_y3-1";
export var paymentMethod = "_y3-e";
export var priceText = "_y3-6";
export var priceTextMobile = "_y3-7";
export var product = "_y3-0";
export var productImage = "_y3-2";
export var productInfo = "_y3-4";
export var productMobile = "_y3-9";
export var productTitle = "_y3-8";
export var quantityBadge = "_y3-3";
export var quantityText = "_y3-5";
export var shippingAddress = "_y3-f";